<template>
    <div class="loader">
        <i class="fas fa-spinner fa-spin loader__spinner"></i> <slot>Loading...</slot>
    </div>
</template>

<script>

export default {
    name: 'component-loader',
};

</script>
